import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getDailyCheckRoleSummaryReport
};



async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function getDailyCheckRoleSummaryReport(data) {

   
    var model = {
        groupID:parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        date: data.searchDate,
        pluckingType: data.pluckingType
    };
    const response = await CommonPost('/api/DailyCheckRoleSummaryReport/GetDailyCheckRoleSummaryReport', null, model);
    return response.data;
}